import { gql, useQuery } from "@apollo/client";
import React from "react";
import { useRouteMatch } from "react-router";
import {
  BreadCrumb,
  BreadCrumbProp,
} from "../../../components/light/Breadcrumb";
import { Content } from "../../../components/light/Content";
import { Loading } from "../../../components/Loading";
import { Graph } from "../../../generated/graph";
import styles from './Stats.module.scss';

const QUERY_LOGINLESS_ORDER_ITEM = gql`
  query QUERY_LOGINLESS_ORDER_ITEM($id: Int!) {
    loginlessOrder(id: $id) {
      customerName
      id
      status
      phoneNumber
    }
    loginlessOrderItemList(id: $id) {
      id
      productId
      code
      picture
      color
      size
      price
    }
  }
`;

function roundnum(value: number) {
  return value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

function renderRow(data: Graph.LoginlessOrderItem[]) {
  return (
    <table className="table table-padded">
      <thead>
        <tr>
          <th style={{ width: 120 }}>Picture</th>
          <th>Code</th>
          <th style={{ width: 120 }}>Color</th>
          <th style={{ width: 120 }}>Size</th>
          <th className="text-right" style={{ width: 120 }}>
            Price
          </th>
        </tr>
      </thead>
      <tbody>
        {data.map(item => (
          <tr key={item.id!}>
            <td>
              <img
                src={item.picture!.toString()}
                alt={item.code!.toString() || ''}
                style={{ width: 100, height: 100 }}
              />
            </td>
            <td>{item.code}</td>
            <td>{item.color}</td>
            <td>{item.size}</td>
            <td className="text-right text-success">
              <b>${roundnum(Number(item.price))}</b>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

function LoginOrderItemBody({
  id,
  orderItemList,
  order,
}: {
  orderItemList: Graph.LoginlessOrderItem[];
  order: Graph.LoginlessOrder;
  id: number;
}) {
  return (
    <>
      <div className="mb-3">
        <div style={{ display: 'flex' }}>
          <div className={styles.stats}>
            <div className={styles.title}>Customer Name</div>
            <div className={styles.value}>{order.customerName || 'No Name'}&nbsp;</div>
            <div className={styles.subtitle}>&nbsp;</div>
          </div>
          <div className={styles.stats}>
            <div className={styles.title}>Phone Number</div>
            <div className={styles.value}>{`0${order.phoneNumber || ''}`}&nbsp;</div>
            <div className={styles.subtitle}>&nbsp;</div>
          </div>
        </div>
      </div>

      {renderRow(orderItemList)}
    </>
  );
}

export function LoginLessOrderDetailScreen() {
  const { params }: any = useRouteMatch();
  const { data, loading } = useQuery<Graph.Query>(QUERY_LOGINLESS_ORDER_ITEM, {
    variables: { id: Number(params.id) },
  });

  const BreadCrumbItems: BreadCrumbProp[] = [
    { text: "applications", to: "#" },
    { text: "orders", to: "#" },
    { text: "orders loginless", to: "/orders/loginless" },
    { text: `#${params.id}`, to: `/orders/loginless/detail/${params.id}` },
  ];

  if (data === undefined || loading) {
    return (
      <Content breadcrumb={<BreadCrumb items={BreadCrumbItems} />}>
        <Loading />
      </Content>
    );
  }

  if(data!.loginlessOrder && data.loginlessOrder.status !== 'PENDING') {
    return (
      <Content breadcrumb={<BreadCrumb items={BreadCrumbItems} />}>
        <p>This order cannot be reviewed</p>
      </Content>
    )
  }

  return (
    <Content breadcrumb={<BreadCrumb items={BreadCrumbItems} />}>
      <div className="row">
        <div className="col-md-6">
          <h4 className="mb-5">Review Loginless Order</h4>
          {
            data!.loginlessOrderItemList && data!.loginlessOrder ? (
              <LoginOrderItemBody
                id={Number(params.id)}
                orderItemList={data.loginlessOrderItemList}
                order={data.loginlessOrder}
              />
            ) : 
            <Loading />
          }
        </div>
      </div>
    </Content>
  );
}
